import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule } from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {EventRegistrationModule} from './modules/event-registration/event-registration.module';
import {InvalidVoucherModule} from './modules/invalid-voucher/invalid-voucher.module';
import {NavbarModule} from './modules/navbar/navbar.module';
import {RegistrationModule} from './modules/registration/registration.module';
import {ThankYouModule} from './modules/thank-you/thank-you.module';
import {EmailConfirmationModule} from './modules/email-confirmation/email-confirmation.module';
import {DataStoreService} from './shared/data-store/services/data-store.service';
import { UnregisterModule } from './modules/unregister/unregister.module';
import { HowToUnregisterModule } from './modules/how-to-unregister/how-to-unregister.module';

import {AppComponent} from './app.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    ThankYouModule,
    RegistrationModule,
    EmailConfirmationModule,
    EventRegistrationModule,
    UnregisterModule,
    InvalidVoucherModule,
    NavbarModule,
    HowToUnregisterModule,
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    DataStoreService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
